var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg001Refresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 60 60",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "138---Refresh",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m59 32v19c0 4.418278-3.581722 8-8 8h-2v-26.33c2.4158535-1.0387644 4.5484343-2.6399143 6.22-4.67 2.1227843.1169277 3.7832179 1.8740003 3.78 4z",
    fill: "#f9d8d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m49 32.67v26.33h-40c-4.418278 0-8-3.581722-8-8v-46c0-2.209139 1.790861-4 4-4h37.5c-6.6955704.00402949-12.7248652 4.05388632-15.2608084 10.2506331-2.5359433 6.1967468-1.0756766 13.3116156 3.6960957 18.0085155 4.7717722 4.6968999 11.9088435 6.0444713 18.0647127 3.4108514z",
    fill: "#f8e8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m55.22 28c-.24.29-.51.56-.77.84.9772295.7572109 1.5494181 1.9237373 1.55 3.16v19c0 4.418278-3.581722 8-8 8h3c4.418278 0 8-3.581722 8-8v-19c.0032179-2.1259997-1.6572157-3.8830723-3.78-4z",
    fill: "#ff9ea1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m23 17.5c0 9.1126984 7.3873016 16.5 16.5 16.5.48 0 1 0 1.41-.08-8.7480754-.8644237-15.2823611-8.4355918-14.8582753-17.2160361.4240859-8.78044429 7.6576126-15.68664206 16.4482753-15.7039639h-3c-9.1126984 0-16.5 7.38730163-16.5 16.5z",
    fill: "#ffc9cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m22 20c0 1.1045695-.8954305 2-2 2h-12c-1.1045695 0-2-.8954305-2-2v-11c0-1.1045695.8954305-2 2-2h12c1.1045695 0 2 .8954305 2 2z",
    fill: "#f9d8d9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 42.5,
    cy: 17.5,
    fill: "#f8e8e9",
    r: 16.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m42.5 1c-.5010337.00119028-1.0016819.02789151-1.5.08 8.4829451.78412711 14.9722055 7.90089127 14.9722055 16.42 0 8.5191087-6.4892604 15.6358729-14.9722055 16.42.4983181.0521085.9989663.0788097 1.5.08 9.1126984 0 16.5-7.3873016 16.5-16.5 0-9.11269837-7.3873016-16.5-16.5-16.5z",
    fill: "#ffc9cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m1 51c0 4.418278 3.581722 8 8 8h3c-4.418278 0-8-3.581722-8-8v-46c0-2.209139 1.790861-4 4-4h-3c-2.209139 0-4 1.790861-4 4z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path",
    d: "m0 43h2v8h-2z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ff414c"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1,
    cy: 47,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m22 16c.5522847 0 1-.4477153 1-1v-6c0-1.65685425-1.3431458-3-3-3h-12c-1.65685425 0-3 1.34314575-3 3v11c0 1.6568542 1.34314575 3 3 3h12c1.6568542 0 3-1.3431458 3-3 0-.5522847-.4477153-1-1-1s-1 .4477153-1 1-.4477153 1-1 1h-12c-.55228475 0-1-.4477153-1-1v-11c0-.55228475.44771525-1 1-1h12c.5522847 0 1 .44771525 1 1v6c0 .5522847.4477153 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m50 54v-3c0-.5522847-.4477153-1-1-1s-1 .4477153-1 1v3c0 .5522847.4477153 1 1 1s1-.4477153 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m6 30h2c.55228475 0 1-.4477153 1-1s-.44771525-1-1-1h-2c-.55228475 0-1 .4477153-1 1s.44771525 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m22 28h-9c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h9c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m6 40h2c.55228475 0 1-.4477153 1-1s-.44771525-1-1-1h-2c-.55228475 0-1 .4477153-1 1s.44771525 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m22 38h-9c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h9c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m22 33h-3c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h3c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m6 35h9c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-9c-.55228475 0-1 .4477153-1 1s.44771525 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m6 53h2c.55228475 0 1-.4477153 1-1s-.44771525-1-1-1h-2c-.55228475 0-1 .4477153-1 1s.44771525 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m22 51h-9c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h9c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m22 46h-3c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h3c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m6 48h9c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-9c-.55228475 0-1 .4477153-1 1s.44771525 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m28 53h2c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-2c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m34 52c0 .5522847.4477153 1 1 1h9c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-9c-.5522847 0-1 .4477153-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m44 48c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-3c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m37 46h-9c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h9c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m42.5 0h-37.5c-2.76142375 0-5 2.23857625-5 5v38c0 .5522847.44771525 1 1 1s1-.4477153 1-1v-38c0-1.65685425 1.34314575-3 3-3h29.4c-7.1473389 3.72495559-10.8237775 11.851834-8.9025025 19.6792506s8.9427451 13.3284447 17.0025025 13.3207494c1.8699536-.0004329 3.7274398-.3043851 5.5-.9v12.9c0 .5522847.4477153 1 1 1s1-.4477153 1-1v-13.71c2.1292428-1.0146551 4.0308303-2.4502007 5.59-4.22 1.3972984.280265 2.4045771 1.5048818 2.41 2.93v19c0 3.8659932-3.1340068 7-7 7h-42c-3.86599325 0-7-3.1340068-7-7 0-.5522847-.44771525-1-1-1s-1 .4477153-1 1c0 4.9705627 4.02943725 9 9 9h42c4.9705627 0 9-4.0294373 9-9v-19c-.0067164-2.0136492-1.2207161-3.8267656-3.08-4.6 3.6812112-5.3533647 4.0916823-12.3061172 1.065943-18.05544154s-8.9890346-9.34770782-15.485943-9.34455846zm6.12 31.74c-1.9316052.8365207-4.015045 1.2654642-6.12 1.26-7.9524299.0007545-14.615246-6.0169251-15.4215866-13.9283697-.8063406-7.9114447 4.5054323-15.14958369 12.2944958-16.7532144 7.7890634-1.60363071 15.5280566 2.94758588 17.9124787 10.5341314 2.3844221 7.5865455-1.3594136 15.746771-8.6653879 18.8874527z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m42 24c-3.8659932 0-7-3.1340068-7-7s3.1340068-7 7-7 7 3.1340068 7 7c0 .5522847.4477153 1 1 1s1-.4477153 1-1c0-4.9705627-4.0294373-9-9-9s-9 4.0294373-9 9 4.0294373 9 9 9c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m55.64 15.23c-.2040826-.1700589-.4674438-.251926-.7319715-.2275369s-.5084803.1530298-.6780285.3575369l-4.23 5.08-4.23-5.08c-.22865-.2750945-.5866924-.407309-.9392563-.3468396-.3525638.0604695-.6460861.3044361-.77.64-.1239138.335564-.0593937.7117451.1692563.9868396l5 6c.1899799.2292703.4722463.3619561.77.3619561s.5800201-.1326858.77-.3619561l5-6c.1700589-.2040826.251926-.4674438.2275369-.7319715s-.1530298-.5084803-.3575369-.6780285z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg001Refresh);
export default __webpack_public_path__ + "static/media/001-refresh.f77e5947652c6cff38320c6ebf0a501d.svg";
export { ForwardRef as ReactComponent };